import { t } from "@lingui/core/macro";

import { EmptyStateIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { Text, VStack } from "@whoosh/design-system/src/components/primitive";

export const GiftCardListEmptyState = () => {
  return (
    <VStack
      alignItems="center"
      gap={4}
      pb={8}
      pt={4}
      px={12}
      testID="gift-cards-empty-state"
    >
      <EmptyStateIcon width={80} height={80} />
      <Text
        variant="mainSmallSemiBold"
        textAlign="center"
      >{t`You currently have no gift cards.`}</Text>
    </VStack>
  );
};
